<template>
    <div class="alert" v-prevent-overscroll>
        <div class="alert-area">
            <div class="prize-wrapper">
                <img class="prize-img" :src="info.$$opts && info.$$opts.prizeBigImg" @click.stop="closeViewPrize" />
            </div>
        </div>
    </div>
</template>

<script>

export default {

    name: 'viewPrize',

    props: {
        info: {
			type: Object,
		},
    },

    data() {
        return {  

        }
    },

    mounted() {
    },

    methods: {
        closeViewPrize() {
            this.$emit('emitEvent', {
                type: 'closeViewPrize',
                data: null,
                options: null
            })
        }
    }

}

</script>

<style lang="scss" scoped>

.alert {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.8);
}

.alert .alert-area {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.prize-img {
    width: 80%;
    margin: 0 auto;
}

</style>